/**
 * API端点常量
 * 统一格式：/api/v1/模块名/xxx
 */
export const API_ENDPOINTS = {
  // 用户管理
  USER: {
    BASE: '/api/v1/user-management/users',
    LOGIN: '/api/v1/user-management/auth/login',
    LOGOUT: '/api/v1/user-management/auth/logout',
    REGISTER: '/api/v1/user-management/users/register',
    PROFILE: '/api/v1/user-management/users/profile',
    CHANGE_PASSWORD: '/api/v1/user-management/users/password',
    OAUTH_URL: (provider: string) => `/api/v1/user-management/auth/oauth/url/${provider}`,
    OAUTH_CALLBACK: (provider: string) => `/api/v1/user-management/auth/oauth/callback/${provider}`,
    OAUTH_PROVIDERS: '/api/v1/user-management/auth/oauth/providers',
    AUTH_CONFIG: '/api/v1/user-management/auth/config',
    // API Key管理
    API_KEYS: '/api/v1/user-management/api-keys/',
    // 团队管理
    TEAMS: '/api/v1/user-management/teams',
    TEAM_BATCH_ADD_MEMBERS: (teamId: number) => `/api/v1/user-management/teams/${teamId}/members/batch`,
    // 用户管理（管理员）
    USERS: '/api/v1/user-management/users',
    BATCH_LOOKUP: '/api/v1/user-management/users/batch-lookup',
    // 账号关联
    LINK_OAUTH: (provider: string) => `/api/v1/user-management/users/oauth/link/${provider}`,
    SET_CREDENTIALS: '/api/v1/user-management/users/credentials',
    // 权限管理
    PERMISSIONS: '/api/v1/user-management/permissions',
    PERMISSIONS_GRANT: '/api/v1/user-management/permissions/grant',
    PERMISSIONS_CHECK: '/api/v1/user-management/permissions/check',
    PERMISSIONS_USER: '/api/v1/user-management/permissions/user',
    PERMISSIONS_TEAM: '/api/v1/user-management/permissions/team',
  },

  // 项目管理
  PROJECT: {
    LIST: '/api/v1/file-management/projects',  // ✅ 移除尾随斜杠，避免307重定向丢失Authorization header
    DETAIL: (id: string) => `/api/v1/file-management/projects/${id}`,
    CREATE: '/api/v1/file-management/projects',  // ✅ 移除末尾斜杠
    UPDATE: (id: string) => `/api/v1/file-management/projects/${id}`,
    DELETE: (id: string) => `/api/v1/file-management/projects/${id}`,
    // 批量获取项目名称（Redis MGET，任务/报告列表用）
    BATCH_NAMES: '/api/v1/file-management/projects/batch-names',
    // 批量获取多个项目的成员（去重，下拉筛选用）
    MEMBERS_BATCH: '/api/v1/file-management/projects/members/batch',
    // 项目成员管理
    MEMBERS: (projectId: string) => `/api/v1/file-management/projects/${projectId}/members`,
    MEMBER_ROLE: (projectId: string, userId: number) => `/api/v1/file-management/projects/${projectId}/members/${userId}`,
    MEMBER_DELETE: (projectId: string, userId: number) => `/api/v1/file-management/projects/${projectId}/members/${userId}`,
  },

  // 项目分组管理
  PROJECT_GROUP: {
    LIST: '/api/v1/file-management/project-groups',
    DETAIL: (id: number) => `/api/v1/file-management/project-groups/${id}`,
    CREATE: '/api/v1/file-management/project-groups',
    UPDATE: (id: number) => `/api/v1/file-management/project-groups/${id}`,
    DELETE: (id: number) => `/api/v1/file-management/project-groups/${id}`,
    MEMBERS: (id: number) => `/api/v1/file-management/project-groups/${id}/members`,
    SET_MEMBERS: (id: number) => `/api/v1/file-management/project-groups/${id}/members`,
  },

  // 文件管理
  FILE: {
    LIST: (projectId: string) => `/api/v1/file-management/projects/${projectId}/files`,
    DETAIL: (projectId: string, fileId: string) => `/api/v1/file-management/projects/${projectId}/files/${fileId}`,
    UPLOAD: (projectId: string) => `/api/v1/file-management/projects/${projectId}/files`,
    DELETE: (projectId: string, fileId: string) => `/api/v1/file-management/projects/${projectId}/files/${fileId}`,
    DOWNLOAD: (projectId: string, fileId: string) => `/api/v1/file-management/projects/${projectId}/files/${fileId}/download`,
  },

  // 文件处理人配置
  FILE_ASSIGNEE: {
    BASE: '/api/v1/file-management/file-assignees',
    DETAIL: (configId: number) => `/api/v1/file-management/file-assignees/${configId}`,
    PRUNE: '/api/v1/file-management/file-assignees/prune',
    BATCH: '/api/v1/file-management/file-assignees/batch',
  },

  // 任务管理
  TASK: {
    LIST: (projectId: string) => `/api/v1/task-management/projects/${projectId}/tasks`,
    DETAIL: (projectId: string, taskId: string) => `/api/v1/task-management/projects/${projectId}/tasks/${taskId}`,
    CREATE: (projectId: string) => `/api/v1/task-management/projects/${projectId}/tasks`,
    DELETE: (taskId: string) => `/api/v1/document-evaluation/tasks/${taskId}`,
  },
} as const
